import { OrderButtons } from '@trashlab/sitesapp/src/templates/redebins/components/shared/order-buttons';

export const HelpfulTipsHeroSection = () => {
  return (
    <section className="relative bg-gray-900 text-white py-20 md:py-32">
      {/* Background image overlay - same as homepage */}
      <div className="absolute inset-0 z-0">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('/redebins/images/hero-background.jpg')",
          }}
        />
        <div className="absolute inset-0 bg-black/10" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-8 italic">
            Helpful Tips
          </h1>

          {/* Order Buttons */}
          <OrderButtons />
        </div>
      </div>
    </section>
  );
};
